"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { FaPercentage, FaMoneyBillWave, FaSave, FaExchangeAlt } from "react-icons/fa"
import "../styles/taxasAdmin.css"

const TaxasAdmin = () => {
  const [taxas, setTaxas] = useState([])
  const [formData, setFormData] = useState({ metodo: "pix", tipo: "porcentagem", valor: "" })
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")
  const [messageType, setMessageType] = useState("")

  const metodosDisponiveis = ["pix", "cartao_credito", "boleto"]

  useEffect(() => {
    fetchTaxas()
  }, [])

  const fetchTaxas = async () => {
    try {
      setLoading(true)
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/taxas`)
      setTaxas(response.data)
      setLoading(false)
    } catch (error) {
      console.error("Erro ao buscar taxas:", error)
      setLoading(false)
    }
  }

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage("")
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/taxas`, formData)
      setMessage("Taxa atualizada com sucesso!")
      setMessageType("success")
      fetchTaxas()
      setFormData({ metodo: "pix", tipo: "porcentagem", valor: "" }) // resetar pra default
    } catch (error) {
      console.error("Erro ao atualizar taxa:", error)
      setMessage("Erro ao atualizar taxa!")
      setMessageType("error")
    } finally {
      setLoading(false)
    }
  }

  const formatarMetodo = (metodo) => {
    switch (metodo) {
      case "pix":
        return "PIX"
      case "cartao_credito":
        return "Cartão de Crédito"
      case "boleto":
        return "Boleto"
      default:
        return metodo.toUpperCase()
    }
  }

  return (
    <div className="taxas-admin-container">
      <h2>Gerenciar Taxas</h2>

      <div className="taxas-atuais">
        <p>Taxas atuais:</p>
        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Carregando taxas...</p>
          </div>
        ) : taxas && taxas.length > 0 ? (
          taxas
            .filter((taxa) => taxa.metodo && taxa.valor !== undefined)
            .map((taxa) => (
              <div key={taxa._id} className="taxa-item">
                <strong>{formatarMetodo(taxa.metodo)}</strong>
                <span className="taxa-valor">
                  {taxa.tipo === "porcentagem" ? (
                    <>
                      <FaPercentage /> {taxa.valor}%
                    </>
                  ) : (
                    <>
                      <FaMoneyBillWave /> R$ {taxa.valor.toFixed(2)}
                    </>
                  )}
                </span>
              </div>
            ))
        ) : (
          <p>Sem taxas cadastradas.</p>
        )}
      </div>

      <div className="taxa-form">
        <h3>Atualizar Taxa</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              <FaExchangeAlt /> Método de Pagamento:
            </label>
            <select name="metodo" value={formData.metodo} onChange={handleInputChange} required>
              {metodosDisponiveis.map((m) => (
                <option key={m} value={m}>
                  {formatarMetodo(m)}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Tipo:</label>
            <select name="tipo" value={formData.tipo} onChange={handleInputChange} required>
              <option value="porcentagem">Porcentagem (%)</option>
              <option value="fixo">Valor Fixo (R$)</option>
            </select>
          </div>

          <div className="form-group">
            <label>{formData.tipo === "porcentagem" ? <FaPercentage /> : <FaMoneyBillWave />} Valor:</label>
            <input
              type="number"
              step="0.01"
              name="valor"
              value={formData.valor}
              onChange={handleInputChange}
              placeholder={formData.tipo === "porcentagem" ? "Ex: 5.5" : "Ex: 10.00"}
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? (
              "Salvando..."
            ) : (
              <>
                <FaSave /> Salvar Taxa
              </>
            )}
          </button>
        </form>

        {message && <div className={`message ${messageType}`}>{message}</div>}
      </div>
    </div>
  )
}

export default TaxasAdmin

